// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__10jkZ"};